import React from 'react'
import './serviceindustries.scss'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonTabs, FigureCards, NewsCard, Faq, SuccessStories, CommonBlueCards } from '../../../components';
import { images } from "../../../utils/customFn";
import { Row, Col, Container } from 'react-bootstrap';
const ServiceIndustries = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/whoweserve/" },
    { label: "Service industry insurance", link: "/whoweserve/serviceindustries" },
  ];

  const HeaderData = [
    {
      image: images['Teamwork_Safety_Smart_Blue.svg'],
      para: 'You know your business backwards and forwards. So when it comes to protecting it, you want someone who knows as much about insuring it. We’ve been protecting businesses like yours for over a century and have the experience to protect yours too. Whether you’re running a small business or choosing an insurance provider for a multinational corporation, we’ll get to know your company so we can help select the right coverages and services for you.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Automotive repair shops',
      description:
        'We’re specially trained in your industry, so you can count on us to help you decide what coverage will help keep your business moving.',
      linkUrl: '',
      linkText: 'More about automotive repair shops >',
    },
    {
      id: 2,
      title: 'Communications businesses',
      description:
        'As technology advances, your company evolves to keep up with the industry. And so should your insurance. Let us help determine the best coverages for you.',
      linkUrl: '/',
      linkText: 'More about communications businesses >',
    },
    {
      id: 3,
      title: 'Educational institutions',
      description:
        'We’re here to help protect you and your employees, so you can stay focused on your top priority—your students.',
      linkUrl: '/',
      linkText: 'More about educational institutions >',
    },

  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Service industry resources',
      description:
        'Explore our resources, featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const tabsData = [
    {
      id: "thesentry",
      href: "#/",
      label: "The Sentry difference",
    },
    {
      id: "weserve",
      href: "#/",
      label: "Who we serve",
    },
  ];
  const activeTabId = "thesentry";
  return (
    <>
      <div className='service-industries-main'>
        {/* hero section */}
        <Hero img={images["ServiceIndustries-Hero.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for service industries" showshare={false} />

          {/* tabs */}
          <CommonTabs tabs={tabsData} activeTab={activeTabId} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} />

          <div className='the-sentry'>
            <Row className='g-0'>
              <Col sm={12} md={4} lg={4} xl={4}>
                <div className='img-wrapper'>
                  <img src={images['ServiceIndustry-SentryDifference.avif']} alt="img" />
                </div>
              </Col>
              <Col sm={12} md={8} lg={8} xl={8}>
                <div className='details-section'>
                  <h1>The Sentry difference</h1>
                  <h2>Helping you save lives, time, and money</h2>
                  <p>Our professional safety consultants are here to help guide you through risk assessments, regulatory changes, and training. An assigned service coordinator will work with you on developing a service plan, analyzing loss trends, and more. Our experienced team can help you reduce and prevent losses.</p>
                  <div className='trust-bottom'>
                    <img src={images['gearsblue.svg']} alt="icon" />
                    <div className='text'>
                      <h3>Safety resources at your fingertips</h3>
                      <p>Our online systems can help you control workplace hazards, reduce costs, and increase productivity.</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {/* dealerships we serve */}
          <NewsCard Title="Who we serve" CardData={ProductCardData} showNavLink={false} subTitle=" " />

          {/* stories */}
          <SuccessStories />

          {/* common blue cards  */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default ServiceIndustries